<template>
  <div class="inviteUsersForm">
    <v-flex xs12 style="text-align: left; font-size: 36px; font-weight: 300;" class="primary--text">Invite new users to <span style="font-weight: 800">{{ userOrganization.name }}</span></v-flex>
    <v-form class="inviteUsersForm" v-if="invitedUsers && invitedUsers.length >= 0">
      <v-flex xs12 mt-1 v-for="(email, index) in invitedUsers" :key="index">
        <v-layout row v-if="invitedUsers[index]">
          <v-text-field :ref="'userEmailField_'+index" :rules="[rules.email]" class="round mt-3 borderClass" solo flat v-model="invitedUsers[index].email" style="height: 45px"></v-text-field>
          <v-flex style="display: flex; align-items: center; flex: none; flex-direction: column;">
            <v-checkbox :ripple="false" color="primary" class="ml-2" label="Admin" v-model="invitedUsers[index].isAdmin" hide-details></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex @click="addField" style="display: flex; align-items: center; cursor: pointer; font-size: 18px" mt-3 class="primary--text">
        <img src="@/assets/add.png" style="width: 22px; height: 22px; margin-right: 5px" />Add another email.
      </v-flex>
    </v-form>

    <v-flex mt-3 style="display: flex; align-items: center; justify-content: center">
      <v-btn class="primary" @click="inviteUsers" flat round :ripple="false" :loading="inviting">Invite Users</v-btn>
    </v-flex>
  </div>
</template>

<style>
.twitterFormInput .theme--light.v-text-field--solo .v-input__slot, .projectInfoTab .theme--light.v-text-field--solo .v-input__slot{
  background: transparent !important;
  padding-left: 5px;
}

.borderClass{
  border: 1px solid #011E41;
}

.twitterFormInput .v-text-field, .projectInfoTab .v-text-field{
  border-radius: 50px;
}

.twitterFormInput .v-input__control{
  min-height: auto !important
}

.twitterFormInput .v-chip{
  margin: 0;
}

.inviteUsersForm .v-input__slot{
  background-color: transparent !important;
  margin-top: 8px;
}

.inviteUsersForm .v-input{
  border-radius: 50px;
}

.inviteUsersForm .v-text-field.v-text-field--solo .v-input__control{
  min-height: 20px !important
}

.inviteUsersForm input{
  padding-bottom: 0;
  padding-top: 0;
  max-height: 45px;
  height: 30px;
}
</style>

<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    inviting: false,
    invitedUsers: [{email: '', isAdmin: false}],
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return value.length === 0 || pattern.test(value) || 'Invalid e-mail.'
      }
    }
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      userOrganization: 'getUserOrganization'
    }),
    adminRoleId () {
      return this.$store.getters['getRoleByName']('ADMIN_ROLE').id
    },
    viewerRoleId () {
      return this.$store.getters['getRoleByName']('VIEWER_ROLE').id
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    inviteUsers () {
      var requests = []
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      for (var i = 0; i < this.invitedUsers.length; i++) {
        if (!this.invitedUsers[i].email || this.invitedUsers[i].email.length === 0 || !pattern.test(this.invitedUsers[i].email)) {
          continue
        }

        var invitation = {
          userId: this.currentUser.id,
          organizationId: this.userOrganization.id,
          organizationRoleId: this.invitedUsers[i].isAdmin ? this.adminRoleId : this.viewerRoleId,
          projectRoleId: null,
          emails: [this.invitedUsers[i].email],
          projectIds: null
        }

        requests.push(this.$store.dispatch('inviteUsers', invitation))
      }

      if (requests.length > 0) {
        this.inviting = true
        axios.all(requests).then((responses) => {
          this.inviting = false
          this.invitedUsers = [{email: '', isAdmin: false}]
        })
      }
    },
    addField () {
      if (this.$refs['userEmailField_' + (this.invitedUsers.length - 1)][0].validate(true)) {
        this.invitedUsers.push({email: '', isAdmin: false})
      }
    }
  },
  mounted: function () {
    this.inviting = false
    this.invitedUsers = [{email: '', isAdmin: false}]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationInviteUsersForm.vue